; (function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.invoice.list')
    .controller('InvoiceListController', InvoiceListController)

  InvoiceListController.$inject = [
    // Urls
    'urls',

    // Angular
    '$state', '$http', '$uibModal', '$window', '$scope',

    // Managers
    'InvoiceManager', 'CreditNoteManager', 'OrderManager',

    // Services
    'DatePickerService', 'SnackService', 'UtilService',
    'FilterSidebarService', 'ColumnService', 'SelectionService',
    'PreferencesService', 'DisplayService', 'FilterService', 'StatusService', 'AppAccessService',

    // Resolve
    'pagination', 'customFields', 'linkedSearch', 'referers', 'chorusStatuses'

  ]

  function InvoiceListController(
    // Urls
    urls,

    // Angular
    $state, $http, $uibModal, $window, $scope,

    // Managers
    InvoiceManager, CreditNoteManager, OrderManager,

    // Services
    DatePickerService, SnackService, UtilService,
    FilterSidebarService, ColumnService, SelectionService,
    PreferencesService, DisplayService, FilterService, StatusService, AppAccessService,

    // Resolve
    pagination, customFields, linkedSearch, referers, chorusStatuses

  ) {
    var self = this

    var customRanges = [
      {
        label: '3 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
      },
      {
        label: '6 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
      },
      {
        label: '1 an',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
      },
      {
        label: '2 ans',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
      }
    ]

    const customRangeCreatedAt = [
      {
        label: 'année dernière',
        range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
      },
      {
        label: 'mois dernier',
        range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
      },
      {
        label: 'semaine dernière',
        range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
      },
      {
        label: 'hier',
        range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
      },
      {
        label: 'aujourd\'hui',
        range: moment().range(moment().startOf('day'), moment().endOf('day'))
      }
    ]

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        pagination: pagination,
        customFields: customFields,
        referers: referers,
        manager: InvoiceManager,
        statuses: StatusService.getStatuses('invoice'),
        cancelByUsers: [
          { label: 'oui', value: true, _id: 'cancel' },
          { label: 'non', value: false, _id: 'cancel' },
        ],
        archive: [
          { label: 'Non-archivées', value: false, _id: 'archived' },
          { label: 'Archivées', value: true, _id: 'archived' },
          { label: 'Toutes', value: 'both', _id: 'archived' }
        ],
        types: [
          { label: 'Acompte', v: 'deposit', _id: 'type' },
          { label: 'Globale', v: 'invoice', _id: 'type' }
        ],
        payment: [
          { label: 'Liquide', value: 'cash', _id: 'payment' },
          { label: 'chèque', value: 'check', _id: 'payment' },
          { label: 'Virement', value: 'wire_transfert', _id: 'payment' },
          { label: 'Avoir', value: 'credit_note', _id: 'payment' },
          { label: 'Report sur Facture', value: 'invoice', _id: 'payment' },
          { label: 'Stripe', value: 'stripe', _id: 'payment' },
          { label: 'Prélèvement', value: 'direct-debit', _id: 'payment' },
          { label: 'Paiement non saisie', value: 'not-documented', _id: 'payment' },
          { label: 'Carte bancaire', value: 'credit-card', _id: 'payment' },
          { label: 'Bon cadeau', value: 'gift-card', _id: 'payment' }
        ],
        statutsCourantChorus: chorusStatuses,
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        haveChorusAccess: false,

        // Methods
        addCriteria: addCriteria,
        archiveInvoice: archiveInvoice,
        asCsv: asCsv,
        asPdf: asPdf,
        asSpreadsheet: asSpreadsheet,
        clearSearch: clearSearch,
        duplicate: duplicate,
        groupFind: FilterService.groupFind,
        searchClients: searchClients,
        searchClientsNumber: searchClientsNumber,
        getDateColor: getDateColor,
        getInvoiceNumber: getInvoiceNumber,
        getList: getList,
        go: go,
        isLate: isLate,
        isVisible: isVisible,
        newTab: newTab,
        restoreInvoice: restoreInvoice,
        searchInvoiceRef: searchInvoiceRef,
        searchInvoiceTitle: searchInvoiceTitle,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        dropColumn: dropColumn,
        sort: sort,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCustomField: isCustomField,
        isCompanyPrefsValid: isCompanyPrefsValid,
        goTo: goTo,
        searchBpus: searchBpus,
        searchDeliveries: searchDeliveries,
        showInterventions: showInterventions,
        selectCreatedAtRange: selectCreatedAtRange,
        criteriaCancelByUser: criteriaCancelByUser
      })
      init()
    }
    // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
    // à la place de self.columns + ng-if="isVisible(col.id)" (45 colonnes x N lignes à chaque digest).
    // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
    // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
    // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
    $scope.$watchGroup([
      () => self.columns,
      () => self.columns && self.columns.map(c => c.id + ':' + !!c.visible).join(',')
    ], updateVisibleColumns)
    // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
    // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
    $scope.$watch(() => self.customFields, updateCustomFieldIds)
    $scope.$on('InvoiceBulkValidate', refreshList)
    $scope.$on('InvoiceBulkStatus', refreshList)

    function init() {
      AppAccessService.getCompanyRights().then((rights) => {
        rights.forEach((right) => {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true
        })
      })
      self.customField = {}
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.noFilter = _.get(companyPrefs.enabledFeatures, 'noFilters', false)
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
        PreferencesService.getPrefsFor('general').then(function (prefs) {
          self.prefs = prefs
          self.columns = UtilService.updateColumnList(ColumnService.getColumns('invoice'), self.customFields, ColumnService.getDefaultColumns('invoice'))
          self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('invoice'), self.customFields, ColumnService.getDefaultColumns('invoice'))
          if (self.noFilter) {
            self.pagination.search = {}
            self.pagination.currentPage = 0
          }
          if (prefs.hasOwnProperty('settings')) {
            if (_.get(prefs.settings.invoiceList, 'pagination')) {
              self.pagination.perPage = _.get(prefs.settings.invoiceList, 'pagination')
            }
            if (_.get(prefs.settings, 'sideBarVisible')) {
              self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
            }
          }
          self.selection.selectedData = []
          if (linkedSearch && !angular.equals({}, linkedSearch)) {
            self.sideBar.filterVisible = true
            initLinkedSearch()
          } else {
            getList()
          }
        })
      })
    }

    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid()
    }

    function isCustomField(key) {
      return _.includes(_.map(self.customFields, 'key'), key)
    }

    function saveColumns(changedCol) {
      let index = self.prefs.settings.invoiceList.columns.findIndex(element => element.id === changedCol.id)
      self.prefs.settings.invoiceList.columns[index].visible = changedCol.visible
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('invoice')
      })
    }

    function resetColumns() {
      self.prefs.settings.invoiceList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('invoice'), self.customFields, ColumnService.getDefaultColumns('invoice'))
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('invoice')
        self.sideBarColumns = ColumnService.getColumns('invoice')
      })
    }

    function criteriaCancelByUser(cancel){
      self.pagination.search = {}
      self.pagination.search = FilterService.addCriteria(self.pagination.search, 'cancelByUser', cancel)
      self.pagination.search = FilterService.addCriteria(self.pagination.search, 'isArchived', { label: 'Archivées', value: true, _id: 'archived' }, true)
      getList()
    }

    function refreshList() {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = []
      }
      self.sideBar.init()
      getList()
    }

    function searchClientsNumber (search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function goTo(invoice) {
      if (invoice.type && invoice.type === 'situation') {
        OrderManager.get(
          OrderManager
            .query({
              conditions: {
                invoices: invoice._id
              },
              populate: JSON.stringify([
                { path: 'invoices' }
              ])
            })
            .fields('invoices')
        ).then(function (data) {
          var order = data.data[0]
          var arrayIndex = _.findIndex(order.invoices, function (elt) {
            return elt._id === invoice._id
          })
          var objIndex = order.invoices.length - arrayIndex
          $state.go('order.show', {
            id: order._id,
            initParams: {
              tabIndex: arrayIndex + 1,
              objIndex: objIndex,
              obj: order.invoices[arrayIndex]
            }
          })
        })
      } else {
        $state.go('invoice.show', { id: invoice._id })
      }
    }

    function initLinkedSearch() {
      if (linkedSearch.hasOwnProperty('status') || linkedSearch.hasOwnProperty('client') || linkedSearch.hasOwnProperty('label')) {
        self.pagination.search = {}
        if (linkedSearch.status) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'status', _.find(self.statuses, function (s) { return s.status === linkedSearch.status }))
        }
        if (linkedSearch.client && linkedSearch.label) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'client', { _id: linkedSearch.client, label: linkedSearch.label })
        }
      } else {
        self.pagination.search = linkedSearch
      }
      getList()
    }

    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('invoice')
      })
    }

    function archiveInvoice(invoice) {
      var content = 'Vous êtes sur le point d\'archiver cette facture.<br><br>Vous ne pourrez plus la modifier ni la dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Archiver', content).then(function () {
        invoice.archive().then(function () {
          SnackService.snack({
            text: 'Facture archivée !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function restoreInvoice(invoice) {
      var content = 'Vous êtes sur le point de restaurer cette facture.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        invoice.restore().then(function () {
          SnackService.snack({
            text: 'Facture restaurée !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function newTab(id) {
      var url = $state.href('invoice.show', { id: id })
      $window.open(url, '_blank')
    }

    function duplicate(invoice) {
      InvoiceManager.findById(invoice._id, InvoiceManager.query({
        populate: JSON.stringify([
          { path: 'referers' },
          { path: 'tags' }
        ])
      })).then(function (completeInvoice) {
        PreferencesService.getPrefsFor('invoice').then(function (prefs) {
          var dup = InvoiceManager.create(completeInvoice.duplicate())
          $state.go('invoice.new', { initParams: dup })
          SnackService.snack({
            text: 'Facture dupliquée !',
            delay: 5000
          })
        })
      })
    }

    function go(invoice) {
      $state.go('invoice.show', { id: invoice })
    }

    function asPdf(invoiceId) {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return 'invoice' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/invoice/'
        if (template !== false) {
          url += template._id
        }
        $http.post(url, { invoices: [invoiceId] }).then(
          function (d) {
            SnackService.snack({
              text: 'Facture exportée en PDF !',
              delay: 5000
            })
          })
      })
    }

    function asCsv(invoiceId) {
      var url = urls.backend + '/services/csv/invoices/'
      $http.post(url, { invoices: [invoiceId] }).then(
        function (d) {
          SnackService.snack({
            text: 'Facture exportée en CSV !',
            delay: 5000
          })
        })
    }

    function asSpreadsheet(invoiceId) {
      var url = urls.backend + '/services/spreadsheet/invoices/'
      $http.post(url, { invoices: [invoiceId] }).then(
        function (d) {
          SnackService.snack({
            text: 'Facture exportée en feuille de calcul !',
            delay: 5000
          })
        })
    }

    function getInvoiceNumber(invoice) {
      if (invoice.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat)
    }

    function isLate(invoice) {
      return invoice.status !== 'paid' && moment().isAfter(moment(invoice.dueDate))
    }

    function sort(name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function getDateColor(invoice) {
      if (invoice.status !== 'paid') {
        if (moment().isAfter(moment(invoice.dueDate))) {
          return 'red'
        } else if (moment(invoice.dueDate).subtract(5, 'days') < moment()) {
          return 'orange'
        }
      }
    }

    function updateVisibleColumns () {
      self.visibleColumns = _.filter(self.columns, 'visible')
    }

    function updateCustomFieldIds () {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      const ids = Object.create(null)
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true
      })
      self.customFieldIds = ids
    }

    function isVisible(columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }

    // SEARCH RELATED

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.pagination.save()
      self.loading = true

      self.pagination.orderBy = self.pagination.orderBy || '-createdAt'

      if (_.isEmpty(self.pagination.search)) {
        addCriteria('isArchived', { _id: 'archived', value: false })
        return
      }
      var q = {
        populate: JSON.stringify([
          {
            path: 'client',
            // firstname/lastname : requis par le contrôle pré-émission
            // Pennylane de la sidebar de sélection (checkInvoiceEmittable,
            // typologie B2C) — simple élargissement de projection, aucune
            // requête supplémentaire.
            select: '__t type firstname lastname number label address'
          },
          {
            path: 'delivery',
            select: '__t type number label address'
          },
          {
            path: 'tags',
            select: 'color label'
          },
          { path: 'referers' },
          { path: 'bpu' }
          // linkedData.solica.interventions n'est plus peuplé : la liste n'en affiche que le
          // nombre (ids), la modale linkedInterventionsModal charge elle-même les interventions
        ]),
        archived: String(FilterService.hasArchivedCriteria(self.pagination.search, true)),
        select: '-stored'
      }
      var query = InvoiceManager
      .query(q)
      .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }

      if (query.opts.conditions.$and) {
        query.opts.conditions.$and.push({ isModel: { $exists: false } })
      } else {
        query.opts.conditions = {
          ...query.opts.conditions,
          isModel: { $exists: false }
        }
      }
      InvoiceManager.post(query).then(function (data) {
        self.pagination.totalElements = data.meta.total
        self.pagination.save()
        self.invoices = _.map(data.data, function (invoice) {
          invoice.lastStatusDate = _.get(_.last(invoice.history), 'date')
          return invoice
        })

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.invoices.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0
          getList(pagination)
        }

        CreditNoteManager.post(CreditNoteManager.query({
          populate: JSON.stringify([
            {
              path: 'invoiceRef',
              select: '_id title'
            }
          ])
        }).select(_.map(self.invoices, '_id'), 'invoiceRef')
          .fields('status invoiceRef'))
          .then(function (data) {
            var grouped = _.groupBy(data.data, 'invoiceRef._id')
            _.forEach(self.invoices, function (invoice) {
              invoice.creditNotes = grouped[invoice._id]
            })
            self.loading = false
          })
      })
    }

    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function clearSearch() {
      self.pagination.search = {}
      getList()
    }

    function searchInvoiceRef(search) {
      return FilterService.searchInvoiceRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function searchInvoiceTitle(search) {
      return FilterService.searchInvoiceTitle(search).then(function (titles) {
        self.titles = titles
      })
    }

    function searchClients(search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchDeliveries(search) {
      if (search) {
        FilterService.searchClients(search, ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing']).then(function (data) {
          self.deliveries = data
        })
      }
    }

    function searchTags(query) {
      return FilterService.searchTags(query)
    }

    function selectDateRange() {
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        dates.start.utcOffset(0, true)
        dates.end.utcOffset(0, true)
        addCriteria('date', dates)
        getList()
      })
    }

    function selectDueDateRange() {
      DatePickerService.getRange(self.pagination.search.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates)
        getList()
      })
    }

    function selectCreatedAtRange() {
      DatePickerService.getRange(self.pagination.search.createdAt, {
        showRanged: true,
        customSelectOptions: customRangeCreatedAt
      }).then(function (dates) {
        addCriteria('createdAt', dates)
        getList()
      })
    }

    function searchBpus(search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus
      })
    }

    function showInterventions(invoice) {
      if (!invoice?.linkedData?.solica?.interventions?.length) {
        return goTo(invoice)
      }

      return $uibModal.open({
        size: 'xl',
        component: 'linkedInterventionsModal',
        resolve: {
          invoice
        }
      })
    }
  }
})(window.angular, window._, window.moment)
